import { Alert, Loader } from '@mantine/core';
import { FormattedMessage } from 'react-intl';

import { CreateReturnPipeline } from './create-return-pipeline';
import { CreateReturnPipelineV0 } from './create-return-pipeline-v0';
import { ReturnDetailsPage } from './return-details-page';
import { ReturnDataProvider } from './return-data-provider';
import { ReturnErrorProvider } from './return-error-provider';
import { useEnsureStoreActivated } from './hooks/use-ensure-store-activated';
import { messages } from './messages';
import { useCreateReturnContext } from '../context/create-return-provider';
import { useIsShipstationReturnsEnabled } from '../../../hooks/use-seller-setting';
import { useEntitiesSalesOrder } from '../../../hooks/entities/selectors/sales-orders';
import { useSalesOrderIdContext } from '../../context/sales-order-id-context-provider';

type EnhancedReturnDetailsProps = {
  returnFulfillmentId: string;
};

export const EnhancedReturnDetails = ({ returnFulfillmentId }: EnhancedReturnDetailsProps) => {
  const salesOrderId = useSalesOrderIdContext();
  const salesOrder = useEntitiesSalesOrder(salesOrderId) ?? {};
  const sellerStoreGuid = salesOrder?.store?.storeGuid;

  const isSSREnabled = useIsShipstationReturnsEnabled();
  const { shouldPromptUserForReturnItems } = useCreateReturnContext();
  const { isReady, error } = useEnsureStoreActivated(sellerStoreGuid);

  if (!isReady) {
    if (error) {
      return (
        <Alert color='red' title={<FormattedMessage {...messages.activationErrorTitle} />}>
          {error}
        </Alert>
      );
    }
    return <Loader />;
  }

  if (sellerStoreGuid && shouldPromptUserForReturnItems) {
    return isSSREnabled ? <CreateReturnPipeline inProgressId={returnFulfillmentId} /> : <CreateReturnPipelineV0 />;
  }

  return (
    <ReturnDataProvider requestId={returnFulfillmentId} storeGuid={sellerStoreGuid}>
      <ReturnErrorProvider>
        <ReturnDetailsPage />
      </ReturnErrorProvider>
    </ReturnDataProvider>
  );
};
